import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2cf21230&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2cf21230&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf21230",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cf21230')) {
      api.createRecord('2cf21230', component.options)
    } else {
      api.reload('2cf21230', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2cf21230&scoped=true", function () {
      api.rerender('2cf21230', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HotpotModal/index.vue"
export default component.exports